<a id="mbfs-header-login-cta" id="auto_trigger" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)" hidden></a> 
  
<!-- Login Modal check user-->
 <form [formGroup]="resetForm" (ngSubmit)="prepareToSaveNewPassword($event)" *ngIf="openLoginModal && this.bodyLoaded">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
  [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div> 

      <!--validateTokenFromEmail Fail Page -->
      <div class="mbfs-modal-content" *ngIf="!invalidToken"> 
        <h3 class="mbfs-modal-header">{{ 'LoginModal.ResetPassword' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner"> 
            <p class="mbfs-passwordreset-p">{{ 'LoginModal.InvalidResetLink' | translate }}</p>
            <p class="mbfs-passwordreset-p">{{ 'LoginModal.OR' | translate }}</p>
            <div class ="registrationlinks">
              <p class="mbfs-passwordreset-p" >{{ 'LoginModal.Registerhref' | translate }}</p>
             </div>
             <button *ngIf="this.adminFlow !='true'" type="submit" class="mbfs-button" (click)="reregister()" >{{ 'LoginModal.ReRegister' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
        </div>
      </div>

      <!--Password Reset Confirm Page -->
      <div class="mbfs-modal-content" *ngIf="invalidToken && confirmReset"> 
        <h3 class="mbfs-modal-header">{{ 'LoginModal.ResetPassword' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner"> 
            <p class="mbfs-passwordreset-p">{{ 'LoginModal.Congratulation' | translate }} </p>                
          <button type="submit" class="mbfs-button" (click)="openLogin($event)">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="openLogin($event)">X</button>
        </div>
      </div>

    <!--validateTokenFromEmail Success Page -->
     <div class="mbfs-modal-content" *ngIf="invalidToken && !confirmReset"> 
      <h3 class="mbfs-modal-header">{{ 'LoginModal.ResetPassword' | translate }}</h3>
      <div class="mbfs-bank-profile-create-inner"> 
          <p class="mbfs-passwordreset-title" >{{ 'LoginModal.SelectPassword' | translate }}</p>
           <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" class="col-md-3 col-form-label">{{ 'LoginModal.SelectPassword1' | translate }}</label>
                <input type="password" name="password" id="password" #password1 class="col-sm-6 form-control"
                formControlName="password" required validateonblur
                value="" onPaste="return false" autocomplete="off" [class.mbfs-value]="resetForm.get('password').value">
                
                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                  <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
           </div>

           <div class="mbfs-text-input" [ngClass]="formValidationClasses">
            <div class="form-group row s-2">
              <div class="input-group">
                <label for="password" class="col-md-3 col-form-label">{{ 'LoginModal.ReEnterPassword' | translate }}</label>
                <input type="password" name="repassword" id="repassword" #password2 class="col-sm-6 form-control"
                formControlName="repassword" required validateonblur
                value="" onPaste="return false" autocomplete="off" [class.mbfs-value]="resetForm.get('repassword').value">
               
                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password2, hide2)">
                  <span class="input-group-text" ><i [ngClass]="hide2 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                </div>
              </div>
            </div>
           </div>
           <div class="testtext">  
              <li style="color:black;"  *ngIf="this.resetForm.get('password') && this.resetForm.get('password').errors && this.resetForm.get('password').errors.pattern">{{ 'LoginModal.SpecialCharacter' | translate }}</li>
              <li style="color:black;"  *ngIf="this.resetForm.get('password') && this.resetForm.get('password').errors && this.resetForm.get('password').errors.required">{{ 'LoginModal.PasswordRequired' | translate }} </li>
              <li style="color:black;"  *ngIf="!this.hasLowerCase">{{ 'LoginModal.LowerCase' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.hasUpperCase">{{ 'LoginModal.UpperCase' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.hasNumeric">{{ 'LoginModal.Numeric' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.hasMinimum">{{ 'LoginModal.Minimum' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.hasMaximum">{{ 'LoginModal.Maximum' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.userIDcheck">{{ 'LoginModal.UserIdCheck' | translate }}</li>
              <li style="color:black;"  *ngIf="!this.reentercheck">{{ 'LoginModal.ReEnterCheck' | translate }}</li>
           </div><br>
           

          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
         
        <button type="submit" class="mbfs-button">{{ 'LoginModal.Cancel' | translate }}</button>
        </div>
      </div>
  </div> 
</form> 
<div class="mbfs-modal-overlay"></div>

    


